module.exports = __webpack_public_path__ + "static/media/de_outdoor_hot_permacool.4875d13b.png";